import { h, Fragment } from "preact";
import { useState, } from "preact/hooks";

import LoadingButton from '@mui/lab/LoadingButton';
import Tooltip from '@mui/material/Tooltip';

export default function LoadingButtonWithTooltip({ id, click, label, icon, disabled, nolabel, tooltip }) {
    console.log({ id, click, label, icon, disabled, nolabel })
    const [loading, setLoading] = useState(false);
    function handleClick() {
        setLoading(true);
        click()
    }

    return (
        <Tooltip title={tooltip}>
            <LoadingButton
                id={id}
                color="primary"
                onClick={handleClick}
                loading={loading}

                loadingPosition="center" //{nolabel ? "center" : "start"}
                startIcon={icon}
                variant="contained"
                disabled={disabled}
                //sx={{ marginRight: "20px" }}
                style={nolabel ? "padding-left: 26px;" : ""}
            >
                {!nolabel && label}
            </LoadingButton>
        </Tooltip>

    );
}